/*****************************************************************************************/
// need to upgrade react-intl depencency https://github.com/yahoo/react-intl/wiki/Upgrade-Guide
var createReactClass = require('create-react-class');
var React = require('react');
var PropTypes = require('prop-types');
React.createClass = createReactClass;
React.PropTypes = PropTypes;
require('./react-intl-v1-stub');
var ReactIntl = require('react-intl').ReactIntl;
window.ReactIntl = ReactIntl;
require('react-intl/locale-data/ru');
var IntlMixin = ReactIntl.IntlMixin;
var innerGetIntlMessage = IntlMixin.getIntlMessage;

IntlMixin.getIntlMessage = function(messageId) {
    try {
        return innerGetIntlMessage.call(this, messageId);
    } catch (error) {
        console.warn(error);
        return '';
    }
};
/************************/
